<template>
  <nav aria-label="breadcrumb" role="navigation">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link to="/home">
          <icon style="fill: #1e4380" name="home" scale="1.5" />
        </router-link>
      </li>
      <li  v-if="!['TrackerDashboard','Tracker'].includes( $route.name )"
        v-for="(item, index) in breadcrumb"
        v-show="index != 0 && item.name != 'Home'"
        :key="index"
        class="breadcrumb-item"
        :class="(index == breadcrumb.length - 1) || (index == 1) ? 'active' : ''"
      >
        <span v-if="index == breadcrumb.length - 1 || index == 1">{{
          $t(item.meta.label)
        }}</span>
        <router-link v-else :to="item.path">
          {{ $t(item.meta.label) }}
        </router-link>
      </li>
    </ol>
  </nav>
</template>
<script>
export default {
  name: "Breadcrumb",
  data: function () {
    return {
      breadcrumb: [],
    };
  },
  watch: {
    $route() {
      this.updateBreadcrumb();
    },
  },
  created: function () {
    this.updateBreadcrumb();
  },
  methods: {
    updateBreadcrumb: function () {
      var TempArray = this.$route.matched.slice(0);
      this.breadcrumb = TempArray;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/variables.scss";
.breadcrumb {
  font-family: $font-subtitle-light;
  background-color: #d9e6f0;
  border-radius: 0px;
  width: 125%;
  margin: 0;
  a {
    color: $primary-color;
  }
  .fa-icon {
    top: -2px;
    position: relative;
  }
}
</style>
